import { ActionButton, Entidade } from '@elotech/components';
import { alert } from 'common/components';
import { useMemo } from 'react';

import { ArquivoService } from '../../service';
import { ArquivoEntity } from '../../type';
import { FileType } from '../../type/enum';

type Props = {
  baseUrl: string;
  resource: string;
  file: ArquivoEntity;
  setLoading: (promise: Promise<any>) => Promise<any>;
  options: Record<string, string>;
  entidadeLogada: Entidade;
};

const TipoSigapArquivoComponent = ({
  file,
  baseUrl,
  resource,
  setLoading,
  options,
  entidadeLogada
}: Props) => {
  const service = useMemo(
    () => new ArquivoService(baseUrl, resource),
    [baseUrl, resource]
  );

  const isInformaSigap = useMemo(() => {
    return (
      entidadeLogada?.uf === 'RO' &&
      file?.arquivo?.mimeType &&
      [
        FileType.DOC.toString(),
        FileType.DOCX.toString(),
        FileType.JPG.toString(),
        FileType.JPEG.toString(),
        FileType.ODS.toString(),
        FileType.ODT.toString(),
        FileType.PDF.toString(),
        FileType.PNG.toString(),
        FileType.PPT.toString(),
        FileType.PPTX.toString(),
        FileType.RTF.toString(),
        FileType.TXT.toString(),
        FileType.XLS.toString(),
        FileType.XLSX.toString(),
        FileType.XML.toString(),
        FileType.ZIP.toString()
      ].includes(file?.arquivo?.mimeType)
    );
  }, [file, entidadeLogada]);

  return (
    <>
      {isInformaSigap && (
        <ActionButton
          icon="money-bill-alt"
          label="Informe o SIGAP"
          onClick={() =>
            alert({
              type: 'question',
              text: 'SIGAP',
              input: 'select',
              inputOptions: options,
              cancelButtonText: 'Cancelar',
              confirmButtonText: 'Confirmar',
              onConfirm: value =>
                setLoading(service.changeTipoSigap(file.id!, value))
            })
          }
        />
      )}
    </>
  );
};

export default TipoSigapArquivoComponent;
